export default __webpack_public_path__ + "static/media/vision.2cf41156.png";